// extracted by mini-css-extract-plugin
export default {"cardBordered":"aEzC29","external":"bEzC29","override":"cEzC29","selected":"dEzC29","cardContent":"eEzC29","column":"fEzC29","columnReverse":"gEzC29"};